import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router';
import store from './store';


import axios from 'axios'

axios.interceptors.response.use(
function(response) {  return response;},
function(error) {
    if( error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false ) {
        return Promise.reject(error);
    }
    
    if (error.response) {
        
        if(error.response.status) {
            
            if(error.response.status == 401) {
                
                router.push("/logout")
            
            } else if(error.response.status == 500) {
                
                //this.$store.state.server_error_show
                //console.log('500 error...')
                store.state.server_error_show = true
                
            } else if(error.response.status == 403) {
                router.push({ name: '403', params : { message : error.response.data.error.message }});

            } else {
                return Promise.reject(error);
            }
            
        }
        return Promise.reject(error);
    }
    
    if(error) {
       // console.log('500 error...')
                store.state.server_error_show = true
        
    }
    
});

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
